module.exports = __webpack_public_path__ + "img/azmin_zuraida.0391c6cd.jpg";